import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NameDescriptionComponent } from '../../name-description/name-description.component';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { HelpIndex, Endpoint, MessageType, UpdateStatusType } from '../../../models/enums';
import { RestService } from '../../../services/rest/rest.service';
import { CommonService } from '../../../services/common/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToggleItem } from '../../../models/toggle-item';
import { DrObject, DrObjectType, SupportedRegExType } from '../../../models/dr-object';

@Component({
    standalone: false,
    selector: 'res-create-sample-modal',
    templateUrl: './create-sample-modal.component.html',
    styleUrls: ['./create-sample-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CreateSampleModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(NameDescriptionComponent, { static: true }) nameDescriptionComponent: NameDescriptionComponent;

    modalTitle = 'Create Sample';
    primaryButtonLabel = 'OK';
    secondaryButtonLabel = 'Cancel';
    modalHelpIndex = HelpIndex.myedisc_create_sampledata_dlg;
    modalAutomationId = 'create-sample';
    modalClass = 'create-sample-modal';
    isBusy = false;
    isBusyMessage = '';
    sampleType = 'by-size';
    dataSetFilterVisible: boolean;
    dataSetFilterQuery = '';
    validateName: boolean;

    validateNameRequest: {
        endpoint: Endpoint,
        request: (name: string) => void
    };

    confidenceInterval: number;
    confidenceLevel: number;
    percentage: number;
    numDocs: number;
    sampleSizeDoc: any;
    totalDocumentCount: number;
    displayTotalDocCount: string;

    toggles = [
        new ToggleItem({
            label: 'Include Families',
        }),
        new ToggleItem({
            label: 'Sample All Custodians'
        })
    ];

    confidenceLevelMap = [
        { key: 90, value: 1.645 },
        { key: 91, value: 1.7 },
        { key: 92, value: 1.75 },
        { key: 93, value: 1.81 },
        { key: 94, value: 1.88 },
        { key: 95, value: 1.96 },
        { key: 96, value: 2.05 },
        { key: 97, value: 2.17 },
        { key: 98, value: 2.33 },
        { key: 99, value: 2.575 }
    ];

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService) {
        super(modalService, modalRef);
    }

    ngOnInit() {
        this.nameDescriptionComponent.isDescriptionHidden = true;
        this.nameDescriptionComponent.createDrObject(DrObjectType.SAMPLE_SET, SupportedRegExType.GENERIC);
        if (this.modalData) {
            if (this.modalData.view) {
                this.totalDocumentCount = this.modalData.view.documentCount;
            } else {
                this.totalDocumentCount = this.modalData.documentCount || this.modalData.numberResults;
            }
            this.displayTotalDocCount = this.numberWithCommas(this.totalDocumentCount);
        }
        this.confidenceLevel = 95;
        this.confidenceInterval = 5;
        this.percentage = 10;

        this.validateName = true;
        this.validateNameRequest = {
            endpoint: Endpoint.viewManager_validateName,
            request: (name) => {
                return {
                    name: this.nameDescriptionComponent.name,
                    projectHandle: this.commonService.currentProject.handle,
                    objectType: 'SAMPLE_SET'
                };
            }
        };
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    percentageChange() {
        this.numDocs = Math.round((this.totalDocumentCount * this.percentage) / 100);
    }

    docCountChange(newValue): void {
        this.numDocs = newValue;
        if (this.numDocs > this.totalDocumentCount) {
            this.numDocs = this.totalDocumentCount;
        }
        this.percentage = ((this.numDocs * 100) / this.totalDocumentCount);
    }

    getSampleSizeDoc() {
        const confLevelValue = this.confidenceLevelMap.find(f => f.key === this.confidenceLevel).value;
        const ss = ((confLevelValue * confLevelValue) * 0.25) / ((this.confidenceInterval / 100) * (this.confidenceInterval / 100));
        this.sampleSizeDoc = Math.round(ss / (1 + ((ss - 1) / this.totalDocumentCount)));
        this.sampleSizeDoc = this.numberWithCommas(this.sampleSizeDoc);
    }

    ok(): void {
        this.nameDescriptionComponent.validate().then(valid => {
            if (valid) {
                const params = {
                    name: this.nameDescriptionComponent.name,
                    acrossCustodians: this.toggles.find((item) => item.label === 'Sample All Custodians').isChecked,
                    confidenceInterval: this.confidenceInterval,
                    confidenceLevel: this.confidenceLevel,
                    includeFamilies: this.toggles.find((item) => item.label === 'Include Families').isChecked,
                    numDocs: this.sampleType === 'by-conf-level' ? this.sampleSizeDoc.replace(',', '') : this.numDocs,
                    percentage: this.percentage,
                    useConfidence: this.sampleType === 'by-conf-level',
                    usePercentage: this.sampleType === 'by-size',
                    viewHandle: this.modalData.view ? this.modalData.view.handle : this.modalData.handle
                };
                this.restService.post(Endpoint.viewManager_createSampleSet, params).then(() => {
                    this.isBusy = false;
                    this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.SAMPLE_SET);
                });
            }
        });
        this.closeModal(true, { name: this.nameDescriptionComponent.name, type: UpdateStatusType.SAMPLE_SET });
    }

    setType(type: string): void {
        this.sampleType = type;
    }

    okEnabled() {
        let enabled = false;
        if (!this.isBusy) {
            if (!DrObject.isEmpty(this.nameDescriptionComponent.name)) {
                if (this.nameDescriptionComponent.isNameDirty() && (this.nameDescriptionComponent.formValid)) {
                    enabled = true;
                }
            }
        }
        return enabled;
    }

}
